/**
 * Typed fetch helpers for the Suade web workspace.
 *
 * All calls are same-origin: in production this bundle is served by the
 * Suade server itself; in dev the webpack dev server proxies /api to the
 * backend (see webpack.config.js), so the session cookie stays first-party.
 */
async function jsonFetch(url, options) {
    const res = await fetch(url, {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        ...options,
    });
    if (!res.ok) {
        let message = `Request failed (${res.status})`;
        try {
            const body = await res.json();
            if (body && body.error)
                message = body.error;
        }
        catch {
            /* non-JSON error body */
        }
        const err = new Error(message);
        err.status = res.status;
        throw err;
    }
    return res.json();
}
// ---- Auth --------------------------------------------------------------
export function getAuthConfig() {
    return jsonFetch("/api/auth/config");
}
export function getMe() {
    return jsonFetch("/api/auth/me");
}
export function signInWithGoogle(credential) {
    return jsonFetch("/api/auth/google", { method: "POST", body: JSON.stringify({ credential }) });
}
export function logout() {
    return jsonFetch("/api/auth/logout", { method: "POST" });
}
// ---- Documents ---------------------------------------------------------
function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            resolve(result.slice(result.indexOf(",") + 1)); // strip data URL prefix
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
}
export async function uploadDocument(file) {
    const base64Content = await fileToBase64(file);
    return jsonFetch("/api/upload-document", {
        method: "POST",
        body: JSON.stringify({
            filename: file.name,
            mimeType: file.type || "application/octet-stream",
            base64Content,
        }),
    });
}
export function classifyDocuments(documents) {
    return jsonFetch("/api/webapp/classify-documents", {
        method: "POST",
        body: JSON.stringify({ documents }),
    });
}
export function getMatterDocuments(matterId) {
    return jsonFetch("/api/webapp/matter-documents", {
        method: "POST",
        body: JSON.stringify({ matterId }),
    });
}
export function generateCaseTheory(payload) {
    return jsonFetch("/api/webapp/generate-case-theory", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}
// ---- Generation --------------------------------------------------------
export function getDocTypes() {
    return jsonFetch("/api/webapp/doc-types");
}
export function startDocumentGeneration(payload) {
    return jsonFetch("/api/webapp/generate-document", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}
export function pollDocumentGeneration(runId) {
    return jsonFetch(`/api/webapp/generate-document/${runId}`);
}
